/**工单动作枚举 */
enum WorkOrderActionEnum {
  /**申请 */
  Add = 1,
  /**更新 */
  Update = 2,
  /**派单 */
  Dispatch = 3,
  /**移交 */
  Transfer = 4,
  /**处理 */
  Processing = 5,
  /**完结 */
  Processed = 6,
  /**撤消 */
  Rescind = 7,
}

export default  WorkOrderActionEnum;
